import { Icon, SvgVolumeOff, SvgVolumeUp, SvgVolumeDown } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../../control-bar-button';

export default function FullscreenButton(props) {
  const hoverTagText = props.muted ? 'Unmute (m)' : 'Mute (m)';

  return (
    <ControlBarButton
      className="video-player-volume-button"
      hoverTagText={hoverTagText}
      seeking={props.seeking}
      onClick={props.onButtonClick}
    >
      {(props.muted || props.volume === 0) && (
        <Icon color="white" icon={<SvgVolumeOff />} />
      )}
      {props.volume <= 0.5 && !props.muted && (
        <Icon color="white" icon={<SvgVolumeDown />} />
      )}
      {props.volume > 0.5 && !props.muted && (
        <Icon color="white" icon={<SvgVolumeUp />} />
      )}
    </ControlBarButton>
  );
}
